export default __webpack_public_path__ + "static/vaccine_banner-e1c8083410c2ddf7faa52138fcbc3e92.png";